import React, { useEffect } from "react";
import styles from "./TourList.module.css";
import { useAppStore } from "../../hooks/store/useAppStore";
import { toursSelector } from "../../hooks/store/getters";
import { getAllTours } from "../../services/TourService";
import { setToursSelector } from "../../hooks/store/setters";
import MapView from "../../components/map-container/MapView";
import { setLoaderSelector } from "../../hooks/store/setters";
import { setAlertMessageSelector } from "../../hooks/store/setters";


const TourListMap = () => {
  const tours = useAppStore(toursSelector);
  const setToursList = useAppStore(setToursSelector);
  const setLoader = useAppStore(setLoaderSelector);
  const setAlertMessage = useAppStore(setAlertMessageSelector);

  useEffect(() => {
    
    const getTours = async () => {
      setLoader("Loading...");
      try {
        const data = await getAllTours();  
        setToursList(data);
      } catch(error) {
        setAlertMessage("Error while loading tours");
      }
      
      setLoader("");
    };
    
    getTours();
    // eslint-disable-next-line
  }, []);

  
  return (
    <div className={styles.TouListMapViewConatiner}>
        <MapView tours={tours}></MapView>
    </div>
  );
};

export default TourListMap;
